import { AUTH_SOURCE } from "../constants/authSource";
import { CRE_EXTENSION_PATH } from "../constants/routes";

const PATIENT_STUDY_PATH = "/patient/Study/getStudyById";

/** Create Templates & Macros (patient app). */
export const PATIENT_TEMPLATES_MACROS_PATH = "/patient/templates-macros";

/** Voice command QA page (STT/TTS harness). */
export const VOICE_TEST_PATH = "/voice-test";

export function isPatientTemplatesMacrosPath(pathname) {
  return pathname === PATIENT_TEMPLATES_MACROS_PATH;
}

export function isVoiceTestPath(pathname) {
  return pathname === VOICE_TEST_PATH;
}

/** Paths that must not be replaced by post-auth redirect to the study patient URL. */
export function shouldSkipPatientAuthRedirect(pathname) {
  return (
    isPatientTemplatesMacrosPath(pathname) ||
    isVoiceTestPath(pathname) ||
    (typeof pathname === "string" && pathname.startsWith(CRE_EXTENSION_PATH))
  );
}

export function buildPatientTemplatesMacrosPath(existingSearch) {
  const qs =
    existingSearch == null || existingSearch === ""
      ? typeof window !== "undefined"
        ? window.location.search
        : ""
      : existingSearch.startsWith("?")
        ? existingSearch
        : `?${existingSearch}`;
  return `${PATIENT_TEMPLATES_MACROS_PATH}${qs}`;
}

export function buildPatientAuthSearchParams({
  token,
  systemCode,
  user,
  existingSearch,
} = {}) {
  const params = new URLSearchParams();
  const studyId = user?.oUserStudy?.studyId ?? user?.studyId ?? null;

  if (studyId) params.set("StudyId", String(studyId));

  if (existingSearch) {
    const existing =
      typeof existingSearch === "string"
        ? new URLSearchParams(
            existingSearch.startsWith("?")
              ? existingSearch.slice(1)
              : existingSearch,
          )
        : existingSearch;

    for (const [key, value] of existing.entries()) {
      if (key === "token" || key === "StudyId" || key === "systemCode") continue;
      params.set(key, value);
    }
  }

  if (systemCode) params.set("systemCode", systemCode);
  if (token) params.set("token", token);

  return params;
}

export function buildPatientAuthPath(options) {
  const qs = buildPatientAuthSearchParams(options).toString();
  return qs ? `${PATIENT_STUDY_PATH}?${qs}` : PATIENT_STUDY_PATH;
}

export function buildCrePatientPath(token, user, existingSearch) {
  return buildPatientAuthPath({
    token,
    user,
    systemCode: AUTH_SOURCE.CRE,
    existingSearch,
  });
}

export function syncAuthTokenInUrl(token) {
  if (!token || typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  if (!params.has("token")) return;
  params.set("token", token);
  const qs = params.toString();
  window.history.replaceState(
    {},
    "",
    `${window.location.pathname}${qs ? `?${qs}` : ""}`,
  );
}
